import { Product, UserRole, USER_LIMITS } from './types';

const PRODUCTS_STORAGE_KEY = 'catalog_products';

// Initialize default products from USER_LIMITS
const getDefaultProducts = (): Product[] => {
  return Object.entries(USER_LIMITS)
    .filter(([role]) => role !== 'admin') // Exclude admin plan
    .map(([role, config]) => ({
      id: role,
      name: config.name,
      price: config.price,
      features: config.features,
      stripePriceId: config.stripePriceId,
      maxUsers: config.users,
      maxPosts: config.maxPosts,
      role: role as UserRole
    }));
};

// Get products from storage or defaults
export const getProducts = (): Product[] => {
  try {
    const savedProducts = localStorage.getItem(PRODUCTS_STORAGE_KEY);
    if (savedProducts) {
      return JSON.parse(savedProducts);
    }
    return getDefaultProducts();
  } catch (error) {
    console.error('Error loading products:', error);
    return getDefaultProducts();
  }
};

// Save products to storage
export const saveProducts = (products: Product[]): void => {
  try {
    localStorage.setItem(PRODUCTS_STORAGE_KEY, JSON.stringify(products));
    // Dispatch custom event to notify components
    window.dispatchEvent(new CustomEvent('productsUpdated'));
  } catch (error) {
    console.error('Error saving products:', error);
  }
};